import * as React from 'react'
import { connect } from 'react-redux'
import {
    Row, Col, Spinner, InputGroup, Input, InputGroupButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button
} from 'reactstrap';

interface IState {
    modal: boolean
    term : string
}
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    term:string
    loading: boolean
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    onSearch: any
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch;


class ListSearch extends React.Component<AllProps, IState> {

    /**
     *
     */
    constructor(props: AllProps) {
        super(props);
        this.state = {
            modal: false,
            term : this.props.term
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.onEnterPressed = this.onEnterPressed.bind(this);
    }
    public componentDidMount() {
    }
    componentDidUpdate(prevProps: AllProps) {
        if (prevProps.term != this.props.term){
            this.setState({term:this.props.term}); 
        }
    }

    onInputChange(e:any) {
        this.setState({ term: e.target.value });
    }
    onEnterPressed(e:any){
        var code = e.keyCode || e.which;
        if(code === 13) { //13 is the enter keycode
            //console.log("Entered");
            this.props.onSearch(this.state);
        } 
    }
    
    public render() {
        return (
            <Row>
                <Col lg="10" >
                    <InputGroup>
                        <Input placeholder="Search for anything" value={this.state.term} onChange={this.onInputChange} onKeyPress={this.onEnterPressed.bind(this)}/>
                    </InputGroup>
                </Col>
                <Col lg="2" >
                    <Button color="success" onClick={this.props.onSearch.bind(this, this.state)} block>
                        <i className="fas fa-search mr-1"></i>
                        &nbsp;&nbsp;Search&nbsp;&nbsp;</Button>
                </Col>
            </Row>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = () => ({
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps
)(ListSearch)